import { render } from "./LegacyExcursionReportSettings.vue?vue&type=template&id=1e6b516b"
import script from "./LegacyExcursionReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacyExcursionReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__